import React, { Component } from "react";
import { Container } from "reactstrap";

import Jumbo from "../Helper/Jumbo";
import Documents from "../Helper/Documents";

class LargeCap extends Component {
  constructor(props) {
    super(props);

    this.title = "Large Cap Growth Mutual Fund";
    this.ticker = "I: CMLIX | R: CAMLX";
    this.objective = "Long-term Capital Growth";
    this.descriptions = [
      [
        "Overview ",
        "Invests in a portfolio of 35-50 companies. Investments are predicated on a company’s future prospects rather than economic or market cycles. We value companies with a history of consistent profitable growth versus a growth now, profits later approach.",
      ],
      [
        "Approach ",
        "We employ a bottom up fundamental process to identify investments in companies with a history of improving fundamentals, emphasizing earnings growth consistency, free cash flow, and solid balance sheet metrics.",
      ],
      [
        "Our Difference",
        "Investing in companies positioned for growth coupled with risk management techniques may provide the foundation to build a high conviction portfolio with consistent return generation and lower realized volatility.",
      ],
	  
    ];

    this.pdfs = [
      ["/Large Cap/large-cap-growth-mutual-fund-fact-card"],
      ["/Large Cap/large-cap-growth-fund-holdings"],
      ["/Large Cap/congress-large-cap-growth-fund(7.31.2026)"],
      ["/Large Cap/congress-large-cap-growth-fund(1.31.2026)"],
      ["/Large Cap/congress_largecap_summary"],
      ["/All/congress_statutory_prospectus"],
      ["/All/congress_sai"],
      ["/All/Congress Funds SemiAnnual Financial Statements and Additional Information 4.30.2026"],
      ["/Large Cap/Congress Large Cap Growth Institutional Class TSR SemiAnnual 4.30.2026"],
      ["/Large Cap/Congress Large Cap Growth Retail Class TSR SemiAnnual 4.30.2026"],
      ["/Large Cap/Congress Large Cap Growth Fund Institutional Class 10.31.25 TSR"],
      ["/Large Cap/Congress Large Cap Growth Fund Retail Class 10.31.25 TSR"],
      ["/All/Annual Financial Statements and Additional Information 2025"],
      ["/All/2026 Capital Gains Flyer"],
    ];
    this.docNames = [
      "FACT SHEET",
      "HOLDINGS",
	"COMPLETE LARGE CAP GROWTH HOLDINGS 7/31/2026",
	"COMPLETE LARGE CAP GROWTH HOLDINGS 1/31/2026",
      "SUMMARY PROSPECTUS",
      "PROSPECTUS",
      "STATEMENT OF ADDITIONAL INFORMATION",
      "SEMI-ANNUAL FINANCIAL STATEMENTS AND ADDITIONAL INFORMATION",
      "SEMI-ANNUAL SHAREHOLDER REPORT - INST CLASS",
      "SEMI-ANNUAL SHAREHOLDER REPORT - RETAIL CLASS",
      "ANNUAL SHAREHOLDER REPORT - INST CLASS",
      "ANNUAL SHAREHOLDER REPORT - RETAIL CLASS",
      "ANNUAL FINANCIAL STATEMENTS AND ADDITIONAL INFORMATION",
      "2026 CAPITAL GAINS ESTIMATES",
      ];
  }

  render() {
    return (
      <Container fluid>
        <Jumbo
          title={this.title}
          ticker={this.ticker}
          objective={this.objective}
          descriptions={this.descriptions}
        />
        <Documents pdfs={this.pdfs} docs={this.docNames} />
			
<p style={{paddingLeft: "9%",paddingRight: "9%", paddingBottom: "5px"}}>Free Cash Flow is a measure of financial performance calculated as operating cash flow minus capital expenditures; represents the cash that a company is able to generate after laying out the money required to maintain or expand its asset base.
</p>
			<p style={{paddingLeft: "9%",paddingRight: "9%",paddingBottom: "5px"}}>Earnings growth is not representative of the fund’s future performance.</p>
			
					<p style={{paddingLeft: "9%",paddingRight: "9%",paddingTop: "10px",fontWeight: "bold", paddingBottom: "2%"}}>Mutual Fund investing involves risk. Principal Loss is possible. The Fund may invest in foreign securities which involve greater volatility and political, economic and currency risks and differences in accounting methods. Investing in small and medium-sized companies involves greater risks than those associated with investing in large company stocks, such as business risk, significant stock price fluctuations and illiquidity. Growth stocks can perform differently from the market as a whole and from other types of stocks. Growth stocks tend to be sensitive to changes in the earnings of their underlying companies and more volatile than other types of stocks, particularly over the short term. To the extent that the Fund invests in ETFs, there will be some duplication of expenses because the Fund would bear its pro rata portion of such ETF’s management fees and operational expenses.
</p>	

      </Container>

    );
  }
}

export default LargeCap;
